module.exports = __webpack_public_path__ + "static/media/logo.cd7e8654.png";